import { DataLayerItem } from '../types';
import AbstractDataLayerManager from './abstractDataLayerManager';
import AppBridge from 'Common/helpers/AppBridge';

class AppsDataLayerManager extends AbstractDataLayerManager {
    protected getRawDataLayer(): DataLayerItem[] {
        return [];
    }

    public setPlatform(): this {
        return this;
    }

    public sendData(data: DataLayerItem): this {
        AppBridge.getInstance(this.logger).sendTrackingData(data);
        return this;
    }
}

export default AppsDataLayerManager;
